exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".schoolRollComponent---3BNi_ {\n  display: -webkit-box;\n  display: -moz-flex;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-direction: normal;\n  -webkit-box-orient: vertical;\n  -moz-flex-direction: column;\n  -ms-flex-direction: column;\n  flex-direction: column;\n  position: fixed;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  overflow-y: scroll;\n  -webkit-overflow-scrolling: touch; }\n\n.mainContent---mxqxf {\n  -webkit-box-flex: 1;\n  -moz-flex: 1;\n  -ms-flex: 1;\n  flex: 1;\n  background-color: #e7e9ea; }\n\n.loadingContainer---14qgb {\n  height: 100%;\n  width: 100%;\n  display: -webkit-box;\n  display: -moz-flex;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: center;\n  -ms-flex-pack: center;\n  -moz-justify-content: center;\n  justify-content: center;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  -moz-align-items: center;\n  align-items: center; }\n\n.loader---3eD3X > div {\n  background-color: #4e5c67 !important;\n  width: 16px !important;\n  height: 16px !important;\n  margin: 4px !important; }\n", ""]);

// exports
exports.locals = {
	"schoolRollComponent": "schoolRollComponent---3BNi_",
	"mainContent": "mainContent---mxqxf",
	"loadingContainer": "loadingContainer---14qgb",
	"loader": "loader---3eD3X"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?modules&localIdentName=[local]---[hash:base64:5]!./~/postcss-loader/lib!./~/sass-loader!./app/containers/school-roll/index.scss
// module id = 1228
// module chunks = 3